<div class="market-history">
  <ul class="nav nav-pills d-flex align-items-center" role="tablist">
    <i class="ion-md-link text-muted mx-2 align-self-center" style="font-size: 20px; vertical-align: middle;"
      *ngIf="isLinked && !isAllDepthView"></i>

    <mat-icon style="font-size: 20px; vertical-align: middle;" *ngIf="isAllDepthView || isOrder"
      (click)="(isOrder)?fetchDepthByOrder():fetchAllDepthByPrice()"
      class="chart-icon text-muted mx-2 align-self-center">refresh</mat-icon>

    <mat-icon style="font-size: 20px; vertical-align: middle;" *ngIf="symbolCode"
      [routerLink]="'/company-profile/'+symbolCode+'/'+reuters"
      class="chart-icon text-muted mx-2 align-self-center">candlestick_chart</mat-icon>

    <mat-icon style="font-size: 20px; vertical-align: middle;" matTooltipPosition="left" [matTooltip]="(translate.currentLang=='en')?'Top 10':'افضل 10'" matTooltipClass="custom-tooltip" [ngClass]="(isAllDepthView)?'allView':''" *ngIf="symbolCode && isAllDepthView && !isOrder && isMarket" (click)="switchView()" class="switch-view-icon text-muted mx-2 align-self-center">unfold_less</mat-icon>

    <mat-icon style="font-size: 20px; vertical-align: middle;" matTooltipPosition="left" [matTooltip]="(translate.currentLang=='en')?'All Market Depth':'جميع العروض والطلبات'" matTooltipClass="custom-tooltip" [ngClass]="(isAllDepthView)?'allView':''" *ngIf="symbolCode && !isAllDepthView && !isOrder && isMarket" (click)="switchView()" class="switch-view-icon text-muted mx-2 align-self-center">unfold_more</mat-icon>


    <li class="nav-item">
      <a class="nav-link active" data-toggle="pill" (click)="toggleOrderView(false)" role="tab" aria-selected="false">
        <h6>{{"price"|translate}}</h6>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link " data-toggle="pill" (click)="toggleOrderView(true)" role="tab" aria-selected="true">
        <h6>{{"order"|translate}}</h6>
      </a>
    </li>

    <input type="text" class="form-control" *ngIf="reuters && isMarket" style="height: 30px; border-radius: 2px;" matTooltipPosition="left" [matTooltip]='companyName' matTooltipClass="custom-tooltip" [(ngModel)]="searchValue" (keyup)="credentialsSearchFilter($event)" [placeholder]="reuters" />

    <span class="widget-reuters" *ngIf="!isMarket && reuters != null" container="body" matTooltipPosition="left" [matTooltip]='companyName' matTooltipClass="custom-tooltip">
      {{reuters}}
    </span>
    <!-- <span class="widget-reuters" container="body" matTooltipPosition="below" [matTooltip]='companyName' *ngIf="false">
      {{reuters}}
    </span> -->
    <li  class="nav-item">
      <span class="last-price-color mx-3">
        {{this.companyData?.LAST_TRADE_PRICE| number: numberFormat  }}
      </span>
    </li>  
  </ul>
  <div class="suggestion-list" *ngIf="searchValue != '' && records?.length > 0 ">
    <div *ngFor="let record of records" class="d-flex justify-content-between search-result-div">
      <div (click)="changecompany(record)"
        style="cursor:pointer;padding-inline-end: 10px;padding-inline-start: 10px;white-space: nowrap;overflow: hidden;align-self:center;text-overflow: ellipsis;vertical-align:middle; text-align: start;">
        {{(translate.currentLang=='en')?record.ENG_NAME:record.ARB_NAME}}
      </div>
    </div>
  </div>
  <div id="recent-trades">
    <table class="table row m-0 p-0 custom-depth" *ngIf="isOrder">
      <thead>
        <tr class="d-flex justify-content-between">
          <th style="text-align: start;">{{"price"|translate}}</th>
          <th class="text-center">{{"qty"|translate}}</th>
          <th style="text-align: end;">{{"price"|translate}}</th>
        </tr>
      </thead>

      <tbody class="custom-tbody" *ngIf="companyDepth != null && companyDepth.bids.length>0 && !isDepthLoading">
        <tr *ngFor="let depth of companyDepth.bids">
          <td class="green">{{depth.ORDER_PRICE | number: numberFormat}}</td>
          <td>{{depth.VOLUME_TRADED | number: "1.0":"en-US"}}</td>
        </tr>
      </tbody>
      <tbody class="custom-tbody" *ngIf="companyDepth!=null && companyDepth.bids.length == 0 && !isDepthLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6 class="nodata-msg"> No Bids </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody class="d-flex justify-content-center custom-tbody" *ngIf="isDepthLoading">
        <div class="spinner-border text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>

      <tbody class="custom-tbody" *ngIf="companyDepth != null && companyDepth.asks.length>0 && !isDepthLoading">
        <tr *ngFor="let depth of companyDepth.asks">
          <td>{{depth.VOLUME_TRADED | number: "1.0":"en-US"}}</td>
          <td class="red">{{depth.ORDER_PRICE | number: numberFormat}}</td>
          <!-- <td>15.27648</td> -->
        </tr>
      </tbody>
      <tbody class="custom-tbody" *ngIf="companyDepth!=null && companyDepth.asks.length == 0 && !isDepthLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6 class="nodata-msg"> No Asks </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody class="d-flex justify-content-center custom-tbody" *ngIf="isDepthLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>

      <tfoot *ngIf="companyDepth" class="totals-footer">
        <tr class="d-flex justify-content-around">
          <div class="green">
            {{companyDepth?.totalsBidsAndAsks?.TOTAL_BIDS | number: "1.0":"en-US"}}
          </div>
          <div>{{'TOTAL'|translate}}</div>
          <div class="red">
            {{companyDepth?.totalsBidsAndAsks?.TOTAL_ASKS | number: "1.0":"en-US"}}
          </div>
        </tr>
      </tfoot>
    </table>

    <table class="table row m-0 p-0 custom-depth" *ngIf="!isOrder">
      <thead>
        <tr class="d-flex justify-content-between">
          <th style="text-align: start;">#</th>
          <th style="text-align: start;">{{"qty"|translate}}</th>
          <th class="text-center">{{"price"|translate}}</th>
          <th style="text-align: end;">{{"qty"|translate}}</th>
          <th style="text-align: end;">#</th>
        </tr>
      </thead>
      <tbody class="custom-tbody"
        *ngIf="companyDepth != null && companyDepth.bidsPerPrice.length > 0 && !isDepthLoading">
        <tr *ngFor="let depth of (isAllDepthView)?allDepth?.bidsPerPrice:companyDepth?.bidsPerPrice  let i = index" class="d-flex">
          <td style="width: 30% !important;position: relative;" 
          [ngClass]="{
            'flash-up': depth.split_UPDATED === 2,
            'flash-down': depth.split_UPDATED === 1,
            'no-change': depth.split_UPDATED === 0
          }">
            <span *ngIf="this.accService.quickButton"
              [ngClass]="(translate.currentLang=='ar')?'quick-buy-r':'quick-buy-l'">
              <button class="border-radios bg-success mx-7 font" (click)="orderBuy(depth, 0)">B</button>
            </span>{{depth.split}}
            <span *ngIf="getFlashingNumber(i, 'order') !== null" class="flashing-number">
              ({{ getFlashingNumber(i, 'order') }})
          </span>
          </td>
          <td style="text-align: center; width: 35% !important;" 
          [ngClass]="{
            'flash-up': depth.VOLUME_TRADED_UPDATED === 2,
            'flash-down': depth.VOLUME_TRADED_UPDATED === 1,
            'no-change': depth.VOLUME_TRADED_UPDATED === 0
          }">
            <div>{{depth.VOLUME_TRADED | number: "1.0":"en-US"}}
              <span *ngIf="getFlashingNumber(i, 'volume') !== null" class="flashing-number">
                ({{ getFlashingNumber(i, 'volume') }})
            </span>
            </div>
          </td>
          <td  
          [style.background]="isDarkTheme ? 'transparent':'#e9ffe9'"
          [style.color]="isDarkTheme ? '#26de81' : '#2cac6c'" style="width: 35% !important;"
          [ngClass]="{
            'flash-up': depth.ORDER_PRICE_UPDATED === 2,
            'flash-down': depth.ORDER_PRICE_UPDATED === 1,
            'no-change': depth.ORDER_PRICE_UPDATED === 0
          }">
            <div style="text-align: end;">{{depth.ORDER_PRICE| number: numberFormat}}</div>
          </td>
          <!-- <td>15.27648</td> -->
        </tr>
      </tbody>
      <tbody class="custom-tbody"
        *ngIf="companyDepth!=null && companyDepth.bidsPerPrice.length == 0 && !isDepthLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6 class="nodata-msg"> No Bids </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody class="d-flex justify-content-center custom-tbody" *ngIf="isDepthLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>
      <!-- <tbody  class="ob-heading" style="height: 50px;" *ngIf="companyDepth != null">
          <tr>
            <td class="red">
              <span>Total Bids</span>
              {{companyDepth.totalsBidsAndAsks.TOTAL_BIDS}}
            </td>
            <td style="width: 20%;" class="green">
              <span>Total Asks</span>
              {{companyDepth.totalsBidsAndAsks.TOTAL_ASKS}}
            </td>
          </tr>
        </tbody> -->
      <tbody class="custom-tbody"
        *ngIf="companyDepth != null && companyDepth.asksPerPrice.length > 0 && !isDepthLoading">
        <tr *ngFor="let depth of (isAllDepthView)?allDepth?.asksPerPrice:companyDepth?.asksPerPrice         
                    let i = index"
           class="d-flex">
          <td             
          [style.background]="isDarkTheme ? 'transparent': '#ffece4'"
          [style.color]="isDarkTheme ? '#ff4643' : '#dc3545'" style="width: 35% !important;"
          [ngClass]="{
            'flash-up': isFlashingIndex(i, 'price','asks', 'up'),
            'flash-down': isFlashingIndex(i, 'price','asks', 'down')}"
            >
            <div>{{depth.ORDER_PRICE | number: numberFormat:"en-US"}}
              <span *ngIf="getFlashingNumber(i, 'price') !== null" class="flashing-number">
                ({{ getFlashingNumber(i, 'price') }})
            </span>
            </div>
          </td>
          <td style="text-align: center;width: 35% !important;"
          [ngClass]="{
            'flash-up': isFlashingIndex(i, 'volume','asks', 'up'),
            'flash-down': isFlashingIndex(i, 'volume','asks', 'down')}"
        >
            <div>{{depth.VOLUME_TRADED | number: "1.0":"en-US"}}
              <span *ngIf="getFlashingNumber(i, 'volume') !== null" class="flashing-number">
                ({{ getFlashingNumber(i, 'volume') }})
            </span>
            </div>
          </td>
          <td style="text-align: end; width: 30% !important;position: relative;"
          [ngClass]="{
            'flash-up': isFlashingIndex(i, 'order','asks', 'up'),
            'flash-down': isFlashingIndex(i, 'order','asks', 'down')
        }"
    >
            <span *ngIf="this.accService.quickButton ==  true"
              [ngClass]="(translate.currentLang=='ar')?'quick-sell-r':'quick-sell-l'">
              <button class="border-radios bg-danger mx-7 font" (click)="orderBuy(depth, 1)">S</button>
            </span>{{depth.split}}
            <span *ngIf="getFlashingNumber(i, 'order') !== null" class="flashing-number">
              ({{ getFlashingNumber(i, 'order') }})
          </span>
          </td>
          <!-- <td>15.27648</td> -->
        </tr>
      </tbody>
      <tbody class="custom-tbody"
        *ngIf="companyDepth!=null && companyDepth.asksPerPrice.length == 0 && !isDepthLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6 class="nodata-msg"> No Asks </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody class="d-flex justify-content-center custom-tbody" *ngIf="isDepthLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>
      <tbody *ngIf="!companyDepth && !isDepthLoading" style="width: 100%; height: 88%;">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <!-- <img class="empty-state" src="/assets/img/noData.png" /> -->
            <img class="empty-state" src="/assets/img/noData.png" />

            <div class="col-sm-12">
              <h6 class="nodata-msg"> {{"select-company-hint"|translate}} </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tfoot *ngIf="companyDepth" class="totals-footer">
        <tr class="d-flex justify-content-around">
          <div class="green">
            {{companyDepth?.totalsBidsAndAsks?.TOTAL_BIDS | number: "1.0":"en-US"}}
          </div>
          <div>{{'TOTAL'|translate}}</div>
          <div class="red">
            {{companyDepth?.totalsBidsAndAsks?.TOTAL_ASKS | number: "1.0":"en-US"}}
          </div>
        </tr>
      </tfoot>

    </table>
  </div>
</div>
